// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div::-webkit-scrollbar {
    width: 3px;
}

div::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
}

body {
    font-family: 'Arial' !important;
    background-color: white !important;
}

.szh-menu-container {
    z-index: 9999 !important;
}

.szh-menu {
    border-radius: 20px !important;
    padding: 6px 0 !important;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12) !important;
    border: none !important;
    min-width: max-content !important;
    z-index: 9999 !important;
}

.szh-menu__item {
    padding: 0 !important;
    min-height: 38px !important;
    display: flex !important;
    align-items: center !important;
}

.szh-menu__item > * {
    width: 100% !important;
    height: 100% !important;
    box-sizing: border-box !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;AAEA;IACI,oDAAoD;IACpD,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,qDAAqD;IACrD,uBAAuB;IACvB,iCAAiC;IACjC,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,iCAAiC;AACrC","sourcesContent":["div::-webkit-scrollbar {\r\n    width: 3px;\r\n}\r\n\r\ndiv::-webkit-scrollbar-track {\r\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\r\n    border-radius: 10px;\r\n}\r\n\r\nbody {\r\n    font-family: 'Arial' !important;\r\n    background-color: white !important;\r\n}\r\n\r\n.szh-menu-container {\r\n    z-index: 9999 !important;\r\n}\r\n\r\n.szh-menu {\r\n    border-radius: 20px !important;\r\n    padding: 6px 0 !important;\r\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12) !important;\r\n    border: none !important;\r\n    min-width: max-content !important;\r\n    z-index: 9999 !important;\r\n}\r\n\r\n.szh-menu__item {\r\n    padding: 0 !important;\r\n    min-height: 38px !important;\r\n    display: flex !important;\r\n    align-items: center !important;\r\n}\r\n\r\n.szh-menu__item > * {\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n    box-sizing: border-box !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
